import { GetPersonOutput } from './person-api.types';

export class Person {
  constructor(private getPersonOutput: GetPersonOutput) {}

  static fromResultArray(personsOutput: GetPersonOutput[]): Person[] {
    return personsOutput.map((personOutput) => new Person(personOutput));
  }

  get id() {
    return this.getPersonOutput.id;
  }

  get geschlecht() {
    switch (this.getPersonOutput.geschlecht) {
      case 1: {
        return 'Männlich';
      }
      case 2: {
        return 'Weiblich';
      }
      case 3: {
        return 'Divers';
      }
      default: {
        return 'Unbekannt';
      }
    }
  }

  set geschlecht(value) {
    switch (value) {
      case 'Männlich':
        this.getPersonOutput.geschlecht = 1;
        break;
      case 'Weiblich':
        this.getPersonOutput.geschlecht = 2;
        break;
      case 'Divers':
        this.getPersonOutput.geschlecht = 3;
        break;
      default:
        this.getPersonOutput.geschlecht = 0;
        break;
    }
  }

  get rawGeschlecht() {
    return this.getPersonOutput.geschlecht;
  }

  get vorname() {
    return this.getPersonOutput.vorname;
  }

  get name() {
    return this.getPersonOutput.name;
  }

  get firmaId() {
    return this.getPersonOutput.firmaId;
  }

  get bemerkung() {
    return this.getPersonOutput.bemerkung;
  }

  get groesseHemd() {
    switch (this.getPersonOutput.groesse_hemd) {
      default: {
        return this.getPersonOutput.groesse_hemd;
      }
    }
  }

  get hemdId() {
    return this.getPersonOutput.hemd_id;
  }

  get hemdInventarnummer() {
    return this.getPersonOutput.hemd_inventarnummer;
  }

  get groesseHose() {
    switch (this.getPersonOutput.groesse_hose) {
      default: {
        return this.getPersonOutput.groesse_hose;
      }
    }
  }

  get hoseId() {
    return this.getPersonOutput.hose_id;
  }

  get hoseInventarnummer() {
    return this.getPersonOutput.hose_inventarnummer;
  }

  get groesseJacke() {
    switch (this.getPersonOutput.groesse_jacke) {
      default: {
        return this.getPersonOutput.groesse_jacke;
      }
    }
  }

  get jackeId() {
    return this.getPersonOutput.jacke_id;
  }

  get jackeInventarnummer() {
    return this.getPersonOutput.jacke_inventarnummer;
  }

  get groesseKittel() {
    switch (this.getPersonOutput.groesse_kittel) {
      default: {
        return this.getPersonOutput.groesse_kittel;
      }
    }
  }

  get kittelId() {
    return this.getPersonOutput.kittel_id;
  }

  get groesseSchuhe() {
    return this.getPersonOutput.groesse_schuhe;
  }

  get schuheId() {
    return this.getPersonOutput.schuhe_id;
  }

  get schuheInventarnummer() {
    return this.getPersonOutput.schuhe_inventarnummer;
  }

  get gruppe() {
    return this.getPersonOutput.gruppe;
  }

  get kleidung() {
    return this.getPersonOutput.kleidung;
  }

  get spinde() {
    return this.getPersonOutput.spinde;
  }

  get firma() {
    return this.getPersonOutput.firma;
  }

  get typ() {
    return this.getPersonOutput.typ;
  }

  get spindeString(): string {
    return (
      this.getPersonOutput.spinde?.map((s) => s.bezeichnung).join(', ') ||
      'Keine Spinde'
    );
  }
}
